import { useCallback, useContext } from 'react'
import { defineMessages } from 'react-intl'
import reopenLoyaltyAccount from 'actions/loyalty/reopenLoyaltyAccount'
import ModalContext from 'contexts/ModalContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import LoyaltyReopenAccountConfirmationModal from 'loyalty/components/LoyaltyReopenAccountConfirmationModal'
import getLoyaltyClosedAccountTier from 'loyalty/lib/getLoyaltyClosedAccountTier'

/**
 * Shared "Reopen account" CTA copy for the surfaces that offer a closed Société account a reopen where
 * they'd otherwise offer to join (points calculator, buy points, reward fares, campaigns).
 */
export const reopenLoyaltyAccountMessages = defineMessages({
  cta: {
    id: 'RWTlHPHM7J98O_221jgH',
    defaultMessage: 'Reopen account',
    description: 'Shared button/link label that reopens the customer\'s closed Société account, shown where Société would otherwise offer to join',
  },
})

/**
 * Returns a callback that confirms with the customer, then reopens their closed Société account.
 * The reopen action decides whether the account can be reopened online.
 */
export default function useReopenLoyaltyAccount() {
  const dispatch = useAppDispatch()
  const showModal = useContext(ModalContext)
  const isInfiniteTier = useAppSelector(state => getLoyaltyClosedAccountTier(state.loyalty.account.error) === 'infinite')

  return useCallback(async() => {
    const confirmed = await showModal<boolean>(<LoyaltyReopenAccountConfirmationModal isInfiniteTier={isInfiniteTier} />)
    if (confirmed) {
      dispatch(reopenLoyaltyAccount())
    }
  }, [dispatch, isInfiniteTier, showModal])
}
